import { FC } from 'react';
import { createFragmentContainer, graphql } from 'react-relay/legacy';
import { PdpSharedDescriptionAbout } from '../PdpSharedDescriptions/PdpSharedDescriptionAbout';
import { PdpSharedDescriptionAdditionalOptions } from '../PdpSharedDescriptions/PdpSharedDescriptionAdditionalOptions';
import { PdpRespDetails } from '../PdpRespDetails/PdpRespDetails';

import { PdpRespAboutModule_item } from './__generated__/PdpRespAboutModule_item.graphql';
import { PdpRespAboutModule_user } from './__generated__/PdpRespAboutModule_user.graphql';
import { PdpRespAboutModule_viewer } from './__generated__/PdpRespAboutModule_viewer.graphql';

import styles from './PdpRespAboutModule.scss';
import { getAttributeInfo } from '../helpers/getAttributeInfo';

type Props = {
    isClient: boolean;
    item: PdpRespAboutModule_item;
    user: PdpRespAboutModule_user;
    viewer: PdpRespAboutModule_viewer;
    currency: string;
    selectedSkuId: string;
};

const PdpRespAboutModuleComponent: FC<Props> = ({
    isClient,
    item,
    user,
    currency,
    selectedSkuId,
    viewer,
}) => {
    const { isCustomizable } = item;
    const { customizationOptions, isResizable } = getAttributeInfo(item?.attributes);
    let showCustomizationOptions = true;
    if ((!isCustomizable || !customizationOptions) && !isResizable) {
        showCustomizationOptions = false;
    }
    const ABOUT_NUM_LINES = showCustomizationOptions ? 6 : 8;
    return (
        <div className={styles.aboutModule}>
            <div className={styles.aboutModuleInner}>
                <div className={styles.aboutColumn}>
                    <PdpSharedDescriptionAbout
                        headerClass={null}
                        item={item}
                        contentClass={styles.paragraphText}
                        collapsedHeight={30 * ABOUT_NUM_LINES} // line height * num lines
                    />
                    {/* Additional Options */}
                    <PdpSharedDescriptionAdditionalOptions
                        user={user}
                        item={item}
                        viewer={viewer}
                        wrapperClass={styles.additionalOptionsWrapper}
                        contentClass={styles.paragraphText}
                        buttonType="transparent"
                        collapsedHeight={30 * 2} // line height * show 2 lines of customization content
                    />
                </div>
                {/* Details */}
                <div className={styles.aboutColumn}>
                    <PdpRespDetails
                        isClient={isClient}
                        currency={currency}
                        item={item}
                        selectedSkuId={selectedSkuId}
                        user={user}
                        viewer={viewer}
                    />
                </div>
            </div>
        </div>
    );
};

export const PdpRespAboutModule = createFragmentContainer(PdpRespAboutModuleComponent, {
    item: graphql`
        fragment PdpRespAboutModule_item on Item {
            isCustomizable
            attributes {
                customizable {
                    text
                }
                ringResizable {
                    value
                }
            }
            ...PdpSharedDescriptionAbout_item
            ...PdpSharedDescriptionAdditionalOptions_item
            ...PdpRespDetails_item
        }
    `,
    user: graphql`
        fragment PdpRespAboutModule_user on User {
            ...PdpSharedDescriptionAdditionalOptions_user
            ...PdpRespDetails_user
        }
    `,
    viewer: graphql`
        fragment PdpRespAboutModule_viewer on Viewer {
            ...PdpRespDetails_viewer
            ...PdpSharedDescriptionAdditionalOptions_viewer
        }
    `,
});
